import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useGame, useEventData } from 'data/hooks'
import numeral from 'numeral'
import 'numeral/locales'

const language = (playmotiv.locale || 'es-es').replace('_', '-');
numeral.locale(language);

try {

  numeral(1000).format('0,0');

} catch (e) {
  // no existe el language en la libraria
  // se puede definir o incluir de algun otro sitio??
  numeral.locale('es-es');
}

const getAwardValue = (id, awards) => {

  const awardValue = awards.reduce((total, award) => {

    if (award.awardType === id) {

      if (isNaN(parseFloat(award.value))) {

        // premio de tipo string (concatenamos)
        if (total === undefined) {
          total = ''
        } else {
          total += ', '
        }
        total += `${award.value}`

      } else {

        // premio de tipo numérico (acumulamos)
        if (total === undefined) total = 0
        total += parseFloat(award.value)

      }
    }
    return total
  }, undefined)

  return awardValue
}

const useShortCode = (type, id, content) => {

  const [value, setValue] = useState('')
  const gameId = useParams().gameId || playmotiv.game.gameId
  const { eventId } = useParams()
  const { game, events, kpis, user, player, data } = useGame(gameId)

  const eventData = useEventData(gameId, eventId)
  let event, kpi

  // FALTA:
  //    AWARD (valores/imágenes ...)
  //    Más propiedades del User  

  useEffect(() => {

    switch (type) {

      case 'game':

        setValue(game[content])

        break;

      case 'user':

        if (id === 'userData') {

          setValue(user.userData[content])
        } else {
          
          setValue(user[content])
        }

        break;

      case 'player':

        setValue(player[content])

        break;

      case 'role':

        setValue(player.roleTitle)

        break;

      case 'event':

        event = events[eventId]

        if (event) {
          setValue(event[content])
        }

        break;

      case 'eventData':

        const slot = eventData.instance.eventData[id]
        if (slot) {
          setValue(slot[content])
        }
        
        break;

      case 'kpi':

        kpi = kpis[id]

        if (!kpi) {
          console.log(`Shortcode: no existe el kpi ${id}`)
        }

        if (content === 'value') {

          const value = eventData.kpis[id]

          if (value) {
            const formatedValue = kpi.mask ? numeral(parseFloat(value)).format(kpi.mask)
              : value
            setValue(formatedValue)
          }

        } else if (kpi) {

          setValue(kpi[content])
        }

        break;

      case 'ranking':

        event = events[eventId]

        if (event) {

          const ranking = event.rankings[id]
          if (ranking) {

            if (content === 'title') {

              setValue(ranking.title)

            } else {

              const rankingData = eventData.rankings[id]

              if (rankingData?.me) {

                if (content === 'value') {

                  kpi = kpis[ranking.kpi]
                  const formatedValue = rankingData.me.value ?
                    kpi.mask ? numeral(parseFloat(rankingData.me.value)).format(kpi.mask)
                      : rankingData.me.value
                    : ''
                  setValue(formatedValue)

                } else {

                  setValue(rankingData.me[content])
                }
              }
            }

          } else {

            console.log(`Shortcode: no existe ranking ${id}`)
          }
        }

        break;

      case 'award':

        event = events[eventId]

        if (event && eventData.awards.length > 0) {

          // recuperamos los premios del contexto del evento
          setValue(getAwardValue(id, eventData.awards))

        } else if (data.awards.length > 0) {

          // recuperamos los premios del contexto de la partida
          setValue(getAwardValue(id, data.awards))
        }

        break;

      default:

        setValue(`${type} ${id} ${content}`)
    }

  }, [type, id, content, eventData])

  return value
}

export default useShortCode
